import type { QueryClient } from "@tanstack/react-query";
import { lazy, Suspense, useEffect, useState } from "react";

const TanstackQueryDevtools = lazy(() =>
	import("@tanstack/react-query-devtools/production").then((d) => ({
		default: d.ReactQueryDevtools,
	})),
);

export interface IRouterContext {
	queryClient: QueryClient;
}

export const DevToolsComponent = () => {
	const [showDevtools, setShowDevtools] = useState(
		process.env.NODE_ENV !== "production",
	);

	useEffect(() => {
		// @ts-expect-error Enable production mode devtools
		window.toggleDevtools = () => setShowDevtools((old) => !old);
	}, []);

	return (
		<>
			{showDevtools && (
				<Suspense fallback={null}>
					<TanstackQueryDevtools buttonPosition="bottom-left" />
				</Suspense>
			)}
		</>
	);
};
